//react
import React from "react";

//UI
import {
  Row,
  Col
} from "antd";

const CorporateContactActivationMessage = () => {
  return (
    <>
      <Row>
        <Col
          xxl={{ span: 12, offset: 6 }}
          xl={{ span: 12, offset: 6 }}
          lg={{ span: 12, offset: 6 }}
          md={{ span: 12, offset: 6 }}
          sm={{ span: 24, offset: 0 }}
          xs={{ span: 24, offset: 0 }}
        >
          <div className="center-container activation-image-container">
            <img
              src="https://d1ml3lw0dsetwo.cloudfront.net/images/GreenCircleCheck.png"
              width="100px"
              height="100px"
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col
          xxl={{ span: 12, offset: 6 }}
          xl={{ span: 12, offset: 6 }}
          lg={{ span: 12, offset: 6 }}
          md={{ span: 12, offset: 6 }}
          sm={{ span: 24, offset: 0 }}
          xs={{ span: 24, offset: 0 }}
        >
          <div className="center-container activation-mid-text">
            <span>Customer has been successfully created!</span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col
          xxl={{ span: 12, offset: 6 }}
          xl={{ span: 12, offset: 6 }}
          lg={{ span: 12, offset: 6 }}
          md={{ span: 12, offset: 6 }}
          sm={{ span: 24, offset: 0 }}
          xs={{ span: 24, offset: 0 }}
        >
          <div className="center-container activation-bottom-text">
            <span>
              Now, Let's send the Corporate User Account activation email.
            </span>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default CorporateContactActivationMessage;
